"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.moveToIJ = exports.create = exports.getAll = void 0;
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(color) {
    // let image: PImage = spritesUtil.createImage(
    //   voyageLayers.getLayers().shipAbove,
    //   sprites.voyTileIndicators[0],
    // )
    // image.tint = color
    var obj = {
        id: -1,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        // image,
        x: 0,
        y: 0,
        timer: 0,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveToIJ(obj, iij) {
    var t = diveTilemap_sidecar_1.diveTilemap.getSafe(iij.i, iij.j);
    if (t) {
        moveToXY(obj, t.x, t.y);
    }
}
exports.moveToIJ = moveToIJ;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    // obj.image.x = obj.x
    // obj.image.y = obj.y
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        // c.image.destroy()
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    //let et = common.getUpdateDeltaScaled()
    obj.timer += ds;
    //let scale = mathUtils.sineLike(obj.timer, 8, 0, 1)
    var scale = mathUtils_sidecar_1.mathUtils.sineLike(obj.timer, 2.5, 0, 1);
    var x = obj.x;
    var y = obj.y + scale * 20 - 14;
    var image = spritesCursors_1.spritesCursors.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsCursorMoveTo[0]);
    var maxTime = 1;
    image.alpha = 1 - obj.timer / maxTime;
}
